@switch (config.type) {
    @case (inputTypes.TEXT) {
        <app-text-input
            [id]="config.id"
            [title]="config.title"
            [label]="config.label"
            [labelPosition]="config.labelPosition"
            [class]="config.class"
            [placeholder]="config.placeholder"
            [initialValue]="config.initialValue"
            [customRoute]="config.customRoute"
            [isDisabled]="config.isDisabled"
            [isRequired]="config.isRequired"
            [isEditMode]="config.isEditMode"
            [validateFn]="config.validateFn"
            [maxLength]="config.maxLength"
            [minLength]="config.minLength"
            [pattern]="config.pattern"
            [password]="config.password"
            [(value)]="value"
            (valueChange)="config.valueChange?.($event)"
            (inputBlur)="config.inputBlur?.()" />
    }
    @case (inputTypes.NUMBER) {
        <app-number-input
            [id]="config.id"
            [title]="config.title"
            [label]="config.label"
            [labelPosition]="config.labelPosition"
            [class]="config.class"
            [placeholder]="config.placeholder"
            [initialValue]="config.initialValue"
            [customRoute]="config.customRoute"
            [isDisabled]="config.isDisabled"
            [isRequired]="config.isRequired"
            [isEditMode]="config.isEditMode"
            [validateFn]="config.validateFn"
            [min]="config.min"
            [max]="config.max"
            [format]="config.format"
            [decimals]="config.decimals"
            [maxLength]="config.maxLength"
            [showSpinners]="config.showSpinners"
            [percentage]="config.percentage"
            [(value)]="value"
            (valueChange)="config.valueChange?.($event)"
            (inputBlur)="config.inputBlur?.()" />
    }
    @case (inputTypes.TEXTAREA) {
        <app-textarea-input
            [id]="config.id"
            [title]="config.title"
            [label]="config.label"
            [labelPosition]="config.labelPosition"
            [class]="config.class"
            [placeholder]="config.placeholder"
            [initialValue]="config.initialValue"
            [customRoute]="config.customRoute"
            [isDisabled]="config.isDisabled"
            [isRequired]="config.isRequired"
            [isEditMode]="config.isEditMode"
            [validateFn]="config.validateFn"
            [maxLength]="config.maxLength"
            [rows]="config.rows"
            [(value)]="value"
            (valueChange)="config.valueChange?.($event)"
            (inputBlur)="config.inputBlur?.()" />
    }
    @case (inputTypes.BOOLEAN) {
        <app-boolean-input
            [id]="config.id"
            [title]="config.title"
            [label]="config.label"
            [labelPosition]="config.labelPosition"
            [class]="config.class"
            [placeholder]="config.placeholder"
            [initialValue]="config.initialValue"
            [customRoute]="config.customRoute"
            [isDisabled]="config.isDisabled"
            [isRequired]="config.isRequired"
            [isEditMode]="config.isEditMode"
            [validateFn]="config.validateFn"
            [nullable]="config.nullable"
            [(value)]="value"
            (valueChange)="config.valueChange?.($event)"
            (inputBlur)="config.inputBlur?.()" />
    }
    @case (inputTypes.DATE) {
        <app-date-input
            [id]="config.id"
            [title]="config.title"
            [label]="config.label"
            [labelPosition]="config.labelPosition"
            [class]="config.class"
            [placeholder]="config.placeholder"
            [initialValue]="config.initialValue"
            [customRoute]="config.customRoute"
            [isDisabled]="config.isDisabled"
            [isRequired]="config.isRequired"
            [isEditMode]="config.isEditMode"
            [validateFn]="config.validateFn"
            [format]="config.format"
            [formatPlaceholder]="config.formatPlaceholder"
            [minDate]="config.minDate"
            [maxDate]="config.maxDate"
            [disabledDates]="config.disabledDates"
            [(value)]="value"
            (valueChange)="config.valueChange?.($event)"
            (inputBlur)="config.inputBlur?.()" />
    }
    @case (inputTypes.DATETIME) {
        <app-datetime-input
            [id]="config.id"
            [title]="config.title"
            [label]="config.label"
            [labelPosition]="config.labelPosition"
            [class]="config.class"
            [placeholder]="config.placeholder"
            [initialValue]="config.initialValue"
            [customRoute]="config.customRoute"
            [isDisabled]="config.isDisabled"
            [isRequired]="config.isRequired"
            [isEditMode]="config.isEditMode"
            [validateFn]="config.validateFn"
            [format]="config.format"
            [formatPlaceholder]="config.formatPlaceholder"
            [minDate]="config.minDate"
            [maxDate]="config.maxDate"
            [disabledDates]="config.disabledDates"
            [(value)]="value"
            (valueChange)="config.valueChange?.($event)"
            (inputBlur)="config.inputBlur?.()" />
    }
    @case (inputTypes.DATERANGE) {
        <app-daterange-input
            [id]="config.id"
            [title]="config.title"
            [label]="config.label"
            [labelPosition]="config.labelPosition"
            [class]="config.class"
            [placeholder]="config.placeholder"
            [initialValue]="config.initialValue"
            [customRoute]="config.customRoute"
            [isDisabled]="config.isDisabled"
            [isRequired]="config.isRequired"
            [isEditMode]="config.isEditMode"
            [validateFn]="config.validateFn"
            [format]="config.format"
            [formatPlaceholder]="config.formatPlaceholder"
            [minDate]="config.minDate"
            [maxDate]="config.maxDate"
            [(value)]="value"
            (valueChange)="config.valueChange?.($event)"
            (inputBlur)="config.inputBlur?.()" />
    }
    @case (inputTypes.TIME) {
        <app-time-input
            [id]="config.id"
            [title]="config.title"
            [label]="config.label"
            [labelPosition]="config.labelPosition"
            [class]="config.class"
            [placeholder]="config.placeholder"
            [initialValue]="config.initialValue"
            [customRoute]="config.customRoute"
            [isDisabled]="config.isDisabled"
            [isRequired]="config.isRequired"
            [isEditMode]="config.isEditMode"
            [validateFn]="config.validateFn"
            [format]="config.format"
            [formatPlaceholder]="config.formatPlaceholder"
            [minTime]="config.minTime"
            [maxTime]="config.maxTime"
            [steps]="config.steps"
            [(value)]="value"
            (valueChange)="config.valueChange?.($event)"
            (inputBlur)="config.inputBlur?.()" />
    }
    @case (inputTypes.FILE) {
        <app-file-input
            [id]="config.id"
            [title]="config.title"
            [label]="config.label"
            [labelPosition]="config.labelPosition"
            [class]="config.class"
            [placeholder]="config.placeholder"
            [initialValue]="config.initialValue"
            [customRoute]="config.customRoute"
            [isDisabled]="config.isDisabled"
            [isRequired]="config.isRequired"
            [isEditMode]="config.isEditMode"
            [validateFn]="config.validateFn"
            [isMultiple]="config.isMultiple"
            [showFileList]="config.showFileList"
            [restrictions]="config.restrictions"
            [(value)]="value"
            (valueChange)="config.valueChange?.($event)"
            (inputBlur)="config.inputBlur?.()" />
    }
    @case (inputTypes.SELECT) {
        <app-select-input
            [id]="config.id"
            [title]="config.title"
            [label]="config.label"
            [labelPosition]="config.labelPosition"
            [class]="config.class"
            [placeholder]="config.placeholder"
            [initialValue]="config.initialValue"
            [customRoute]="config.customRoute"
            [isDisabled]="config.isDisabled"
            [isRequired]="config.isRequired"
            [isEditMode]="config.isEditMode"
            [validateFn]="config.validateFn"
            [options]="config.options"
            [isMultiple]="config.isMultiple"
            [isFilterable]="config.isFilterable"
            [isClearable]="config.isClearable"
            [textField]="config.textField"
            [valueField]="config.valueField"
            [popupSettings]="config.popupSettings"
            [defaultItem]="config.defaultItem"
            [customFilter]="config.customFilter"
            [valuePrimitive]="config.valuePrimitive"
            [(value)]="value"
            (valueChange)="config.valueChange?.($event)"
            (inputBlur)="config.inputBlur?.()" />
    }
    @case (inputTypes.CODELIST) {
        <app-codelist-input
            [id]="config.id"
            [title]="config.title"
            [label]="config.label"
            [labelPosition]="config.labelPosition"
            [class]="config.class"
            [placeholder]="config.placeholder"
            [initialValue]="config.initialValue"
            [customRoute]="config.customRoute"
            [isDisabled]="config.isDisabled"
            [isRequired]="config.isRequired"
            [isEditMode]="config.isEditMode"
            [validateFn]="config.validateFn"
            [codelist]="config.codelist"
            [isMultiple]="config.isMultiple"
            [textField]="config.textField"
            [valueField]="config.valueField"
            [popupSettings]="config.popupSettings"
            [omittedCodelistIds]="config.omittedCodelistIds"
            [formatLabel]="config.formatLabel"
            [customFilter]="config.customFilter"
            [(value)]="value"
            (valueChange)="config.valueChange?.($event)"
            (inputBlur)="config.inputBlur?.()" />
    }
}
